<script>
import {
  ofacReportMethods,
  orderReportMethods,
  toasterMethods,
  userMethods,
} from '@state/helpers'
import constant from '@constants/constant'
import common from '@state/modules/common'
export default {
  props: {
    customerId: {
      type: Number || String,
      default: '',
    },
    customerUserId: {
      type: Number || String,
      default: '',
    },
    productId: {
      type: String,
      default: '',
    },
    productAddOns: {
      type: Array,
      default: Array,
    },
  },
  data() {
    return {
      errorLog: '',
      displayAlert: false,
      alertMessage: '',
      showSpinner: false,
      referenceno: '',
      firstName: '',
      middleName: '',
      lastName: '',
      addressLine1: '',
      addressLine2: '',
      cityName: '',
      state: '',
      stateCode: '',
      zip: '',
      phoneNumber: '',
      reportType: 1,
      typeOption: [
        { text: 'Financial', value: 1 },
        { text: 'Non Financial', value: 2 },
      ],
    }
  },
  computed: {
    placeholders() {
      return {
        referenceno: 'Reference Number',
        firstName: 'First Name',
        middleName: 'Middle Name',
        addressLine1: 'Address Line 1',
        addressLine2: 'Address Line 2',
        lastName: 'Last Name',
        cityName: 'City Name',
        state: 'Select State',
        zip: 'xxxxx-xxxx',
        phoneNumber: '(xxx) xxx-xxxx',
        legaldescription: 'Legal Description',
      }
    },

    states() {
      return this.$_allStates
    },
  },

  methods: {
    ...ofacReportMethods,
    ...orderReportMethods,
    ...userMethods,
    ...toasterMethods,
    async getModal(message, type, method) {
      await this.$refs.msg.showAsync(message, type, 'Ok').then(() => {
        if (method) {
          method()
        }
      })
    },
    onReportSubmit(selectedValue) {
      this.getStateCode()
      let userInfo = this.$store.state.auth.currentUser.userInfo
      var isOrderReportComponentValid = false
      var isOFACPrincipalReportComponentValid = false
      this.currentUserId = userInfo.userId
      var that = this
      this.$parent.$parent.$validator.validateAll().then((response) => {
        isOrderReportComponentValid = response
        this.$validator.validate().then((response) => {
          if (userInfo.roles.indexOf(constant.CreditAnalystOrLoanOfficer) !== -1) {
            isOrderReportComponentValid = response
            that.customerUserId = that.currentUserId
          }
          isOFACPrincipalReportComponentValid = response
          if (
            isOrderReportComponentValid &&
            isOFACPrincipalReportComponentValid
          ) {
            if (that.firstName && that.lastName) {
              that.showSpinner = true
              that
                .fetchOfacPrincipalReport({
                  userId: that.currentUserId,
                  stateCode: that.stateCode,
                  customerId: that.customerId,
                  customerUserId: that.customerUserId,
                  productId: that.productId,
                  firstName: that.firstName,
                  middleName: that.middleName,
                  lastName: that.lastName,
                  addressLine1: that.addressLine1,
                  addressLine2: that.addressLine2,
                  city: that.cityName,
                  stateId: that.state,
                  referenceno: that.referenceno,
                  reportType: that.reportType,
                  zip: that.zip,
                })
                .then((response) => {
                  if (
                    response.data !== null &&
                    response.data.responseStatus === 1 &&
                    response.data.reportByteArray !== undefined
                  ) {
                    let url = common.downloadFile(
                      response.data.reportByteArray,
                      constant.contentType.pdf,
                      constant.products.OfacPrincipal
                    )
                    this.$router.open({
                      name: 'pdfviewer',
                      query: {
                        url: url,
                      },
                    })
                    this.$emit('resetOrderReport')
                  } else if (
                    response.data.responseStatus === 3 ||
                    response.data.responseStatus === 5 ||
                    response.data.responseStatus === 0
                  ) {
                    this.setAlert({
                      title: constant.imageHeaderError,
                      msg: response.data.message,
                      variant: constant.errorMessagetype,
                    })
                    this.$emit('resetOrderReport')
                  } else if (
                    response.data.message !== '' &&
                    response.data.message !== null &&
                    response.data.message !== undefined
                  ) {
                    this.setAlert({
                      title: constant.imageHeaderError,
                      msg: response.data.message,
                      variant: constant.errorMessagetype,
                    })
                  } else {
                    this.setAlert({
                      title: constant.imageHeaderError,
                      msg: constant.errorMessage,
                      variant: constant.errorMessagetype,
                    })
                  }
                  this.showSpinner = false
                })
                .catch((error) => {
                  this.showSpinner = false
                  this.setAlert({
                    title: constant.imageHeaderError,
                    msg: constant.errorMessage,
                    variant: constant.errorMessagetype,
                  })
                  this.errorLog = error
                })
            } else {
              this.getModal('Please enter borrower name.', 'Alert')
            }
          }
        })
      })
    },
    getStateCode() {
      if (this.state !== '') {
        this.stateCode = this.states.find(
          (x) => x.value === Number(this.state)
        ).stateCode
      }
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
  },
}
</script>

<template>
  <div>
    <BaseModalLayout ref="msg" hide-cancel modal-size="md" />
    <BaseAlert
      v-if="displayAlert"
      class="w-25"
      :class="$style.alertMsgPosition"
    >
      {{ alertMessage }}
    </BaseAlert>
    <BaseSpinner v-if="showSpinner" />
    <b-row>
      <b-col md="12" class="pb-3" />
      <b-col md="3">
        <BaseEInputText
          id="referenceno"
          v-model="referenceno"
          v-validate="{ required: false, regex: /^[A-Za-z0-9]+$/ }"
          validattor="^[A-Za-z0-9]+$"
          data-vv-as="Reference No."
          type="text"
          maxlength="50"
          name="referenceno"
          label-content="Reference Number"
          :placeholder="placeholders.referenceno"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('referenceno') }} </div>
      </b-col>

      <b-col md="6" class="d-none">
        <BaseELabel mark-required labe="Report Type" />
        <b-form-group>
          <b-form-radio-group
            :key="typeOption.id"
            v-model="reportType"
            :options="typeOption"
            class="mr-5"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mt-2" align-v="center">
      <b-col class="border-bottom"></b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="firstName"
          v-model="firstName"
          v-validate="{
            required: true,
            regex: /^[A-Za-z0-9-]+$/,
          }"
          validattor="^[A-Za-z0-9-]+$"
          data-vv-as="First Name"
          type="text"
          name="firstName"
          maxlength="50"
          label-content="First Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('firstName'),
          }"
          :placeholder="placeholders.firstName"
          aria-describedby="firstName-live-feedback"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('firstName') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="middleName"
          v-model="middleName"
          v-validate="{ required: false, regex: /^[A-Za-z0-9-]+$/ }"
          validattor="^[A-Za-z0-9-]+$"
          data-vv-as="Middle Name"
          type="text"
          name="middleName"
          maxlength="50"
          label-content="Middle Name"
          :class="{
            input: true,
            'is-danger': errors.has('middleName'),
          }"
          :placeholder="placeholders.middleName"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('middleName') }} </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="lastName"
          v-model="lastName"
          v-validate="{
            required: true,
            regex: /^[A-Za-z0-9-]+$/,
          }"
          validattor="^[A-Za-z0-9-]+$"
          data-vv-as="Last Name"
          type="text"
          name="lastName"
          maxlength="50"
          label-content="Last Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('lastName'),
          }"
          :placeholder="placeholders.lastName"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('lastName') }} </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <BaseEInputText
          id="addressLine1"
          v-model="addressLine1"
          v-validate="{ required: true }"
          data-vv-as="Address Line 1"
          type="text"
          name="addressLine1"
          maxlength="100"
          label-content="Address Line 1"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('addressLine1'),
          }"
          :placeholder="placeholders.addressLine1"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('addressLine1') }} </div>
      </b-col>
      <b-col md="6">
        <BaseEInputText
          id="addressLine2"
          v-model="addressLine2"
          v-validate="{ required: false }"
          data-vv-as="Address Line 2"
          type="text"
          name="addressLine2"
          maxlength="100"
          label-content="Address Line 2"
          :class="{
            input: true,
            'is-danger': errors.has('addressLine2'),
          }"
          :placeholder="placeholders.addressLine2"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('addressLine2') }} </div>
      </b-col>
    </b-row>
    <b-row class="border-bottom pb-4">
      <b-col md="3">
        <BaseEInputText
          id="cityName"
          v-model="cityName"
          v-validate="{ required: true, regex: /^[A-Za-z -]+$/ }"
          validattor="^[A-Za-z -]+$"
          data-vv-as="City"
          type="text"
          name="cityName"
          maxlength="20"
          label-content="City"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('city'),
          }"
          :placeholder="placeholders.cityName"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('cityName') }} </div>
      </b-col>
      <b-col md="2">
        <BaseELabel mark-required label="State" />
        <BaseDropdown
          v-model="state"
          v-validate="'required'"
          data-vv-as="State"
          :field-id="state"
          :options="states"
          name="state"
          :placeholder="placeholders.state"
        ></BaseDropdown>
        <div class="error"> {{ errors.first('state') }} </div>
      </b-col>
      <b-col md="2">
        <BaseEInputText
          id="zip"
          v-model="zip"
          v-validate="{ required: true, regex: /^[0-9]{5}(?:-[0-9]{4})?$/ }"
          validattor="[0-9]"
          data-vv-as="Zip"
          maskker="(\d{5})(\d{4})"
          formatter="$1-$2"
          type="text"
          maxlength="10"
          name="zip"
          label-content="Zip"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('zip'),
          }"
          :placeholder="placeholders.zip"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('zip') }} </div>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col md="3">
        <BaseEButton @click="onReportSubmit">
          Submit
        </BaseEButton>
      </b-col>
    </b-row>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.alertMsgPosition {
  position: absolute;
  top: 350px;
  right: 0;
}
</style>
